'use strict'

import noTranslatedTerms from "./noTranslatedTerms"

var libTranslate = null
var language = null
var notranslateAlreadyAddInArray = {}

const notExist = (screen, term) => {

    if(!notranslateAlreadyAddInArray[language.ID]){
        notranslateAlreadyAddInArray[language.ID] = {}
        noTranslatedTerms().push({screen: screen, term: term, language: language.ID})
    } else if(!notranslateAlreadyAddInArray[language.ID][screen]) {
        notranslateAlreadyAddInArray[language.ID][screen] = {}
        noTranslatedTerms().push({screen: screen, term: term, language: language.ID})
    } else if(!notranslateAlreadyAddInArray[language.ID][screen][term]) {
        notranslateAlreadyAddInArray[language.ID][screen][term] = {}
        noTranslatedTerms().push({screen: screen, term: term, language: language.ID})
    }
    return term

}

const getTranslateTerm = (screen, term) => {
    if(!libTranslate[language.ID]) return notExist(screen, term)
    if(!libTranslate[language.ID][screen]) return notExist(screen, term)
    if(!libTranslate[language.ID][screen][term]) return notExist(screen, term)
    return libTranslate[language.ID][screen][term]

}

// Descarta a biblioteca em memória; a próxima tradução relê o localStorage
export const resetLibTranslate = () => {
    libTranslate = null
}

export default (screen, term) => {

    language = localStorage.getItem('language')
    if(!language || language == 'undefined' || language == 'null') return term
    language = JSON.parse(localStorage.getItem('language'))
    if(!libTranslate) libTranslate = localStorage.getItem('libTranslate') ? JSON.parse(localStorage.getItem('libTranslate')) : {}

    return getTranslateTerm(screen, term)
}